<template>
    <section container>
        <section content padding>
            <Row>
                <Col :xs="24" :sm="12" :md="8" :lg="8" v-for="(item, index) in story" :key="index">
                    <div class="public-shell" margin>
                        <div class="photo-view rectangle">
                            <img :preview="new Date().getTime()" :src="item.cover"/>
                        </div>
                        <br/>
                        <h2 class="overflow-text" @click.stop="onItem(item, index)"><a>{{ item.title }}</a></h2>
                        <h3>{{ item.desc }}</h3>
                        <br/>
                        <p>
                            <Button ghost shape="circle" size="large" type="primary" @click.stop="onItem(item, index)">{{ $common.config.lang === 'cn' ? '查看详情' : 'View More' }}</Button>
                        </p>
                    </div>
                </Col>
            </Row>
        </section>
    </section>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                story: [],
            }
        },
        created() {
        },
        mounted() {
            this.getStory();
        },
        methods: {
            async getStory(){
                let res = await this.$api.getHttp('/story/list?lang=' + this.$common.config.lang);
                this.story = [] = res.data.data.data.sort(this.$common.arraySorting('createTime'));
                console.log('this.getStory---------->', this.story);
            },
            onItem(data, i){
                console.log('this.onItem---------->', data, i);
                this.$router.push({
                    name: 'article',
                    query: {
                        id: data.id,
                        model: 'story',
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/story/index.vue